import { render, staticRenderFns } from "./Informativa-sulla-privacy.vue?vue&type=template&id=46ff3dae&scoped=true&"
import script from "./Informativa-sulla-privacy.vue?vue&type=script&lang=js&"
export * from "./Informativa-sulla-privacy.vue?vue&type=script&lang=js&"
import style0 from "./Informativa-sulla-privacy.vue?vue&type=style&index=0&id=46ff3dae&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff3dae",
  null
  
)

export default component.exports